export const deprecatedProperties = ["session ID", "last event time", "Site Type"];

export const propertiesToResetOnPageview = [
  "date_range",
  "domain_type",
  "entity_id",
  "entity_name",
  "entity_type",
  "main_category",
  "sub_category",
  "sub_sub_category",
  "tab",
  "ab_test_name",
  "ab_test_value",
  "custom_category_id",
  "custom_category_name",
  "is_shared_custom_category",
  "category_type",
  "order_by",
  "page",
  "device_os",
  "store",
  "web_source",
  "country",
  "section",
  "sub_section",
  "sub_sub_section",
  "domains_amount",
  "segments_amount",
  "entities_amount",
  "is_asset_owner",
];
